import ReactQuill from "react-quill";
import React, { useEffect, useState } from "react";
/*import debounce from "../helpers";*/
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import BorderColorIcon from "@material-ui/icons/BorderColor";

function EditorComponent({
  classes,
  selectedNote,
  selectedNoteIndex,
  notes,
  noteUpdate,
}) {
  const [text, setText] = useState(selectedNote.body);
  const [title, setTitle] = useState(selectedNote.title);
  const [id, setId] = useState(selectedNote?.id);

  useEffect(() => {
      
    setText(selectedNote.body);
    setTitle(selectedNote.title);
    setId(selectedNote.id);
  }, [setText,selectedNote.body,setTitle,selectedNote.title,setId,selectedNote.id]);

    function updateTitle (txt){
   
     setTitle(txt);
    /* console.log(txt);
     console.log(title);
     update();*/
  };

  const updateBody =  (val) => {
     setText(val);
    /*console.log(val);
    console.log(text)
    update();*/
  };

  

    
  useEffect(() => {
    let timeout =  setTimeout(() => {
        
      noteUpdate(id, {
        title: title,
        body: text,
      });
    }, 1500);
    return () => clearTimeout(timeout);
  }, [text, title,noteUpdate,id]);
  

  /* const update = debounce(() => {
    noteUpdate(id, {
      title: title,
      body: text,
    });
  }, 1500);*/

  return (
    <div className={classes.editorContainer}>
      <BorderColorIcon className={classes.editIcon}></BorderColorIcon>
      <input
        className={classes.titleInput}
        placeholder="Note title..."
        value={title ? title : ""}
        onChange={(e) => {updateTitle(e.target.value)
        console.log(e.target.value)}}
      ></input>
      <ReactQuill value={text} onChange={updateBody}></ReactQuill>
    </div>
  );
}

export default withStyles(styles)(EditorComponent);
